export const Layers = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_6098)">
<path d="M3.00574 10.0003L16.0002 3.00783L29.0054 10.0003L16.0002 16.9978L16.474 17.8784L16.0002 16.9978L3.00574 10.0003Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M3.0004 16.0092L15.9499 22.9758C15.9795 22.9917 16.0151 22.9917 16.0447 22.9758L29 16.0078" stroke="currentColor" stroke-width="2"/>
<path d="M3.0004 22.0023L15.9499 28.9688C15.9795 28.9847 16.0151 28.9847 16.0447 28.9688L29 22.0009" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_1_6098">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;
